import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AttributionLinkSource } from 'common/constants/attribution-link-source';

import { UpdateProductAction } from '../../../context/page-form-context';

type TError = { message: string; code?: number };

export interface GenerateTemporaryLinkState {
  links: {
    created:
    {
      asin: string,
      link: string
    }[]

    updated:
    {
      asin: string,
      link: string
    }[]
    ,
    notFoundAsins: string[]
  };
  isLoading: boolean;
  error: TError;
}

export type ChangeAction<K extends keyof GenerateTemporaryLinkState> = PayloadAction<{
  key: K;
  value: GenerateTemporaryLinkState[K]
}>;

export type ActionPayloadWithMeta<T extends any, K extends any> = PayloadAction<{
  payload: T,
  meta?: K
}>;

export interface GenerateTemporaryLinkActionPayload {
  expired_at?: string,
  publisher_id: number,
  asins: string[],
  region?: string,
  source: AttributionLinkSource,
}

export interface GenerateTemporaryLinkActionMeta {
  onSuccess?: UpdateProductAction
}

const initialState: GenerateTemporaryLinkState = {
  error: null,
  isLoading: false,
  links: null
};

export const generateTemporaryLinksSlice = createSlice({
  initialState,
  name: 'generateTemporaryLinks',
  reducers: {
    change: <K extends keyof GenerateTemporaryLinkState>(
      state: GenerateTemporaryLinkState,
      action: ChangeAction<K>
    ) => {
      state[action.payload.key] = action.payload.value;
    },
    error: (state, action: PayloadAction<GenerateTemporaryLinkState['error']>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    generate: (
      ...args: [
        GenerateTemporaryLinkState,
        ActionPayloadWithMeta<GenerateTemporaryLinkActionPayload,
        GenerateTemporaryLinkActionMeta>]
    ) => {
      const [state] = args;

      state.isLoading = true;
      state.error = null;
    },
    resetState: () => initialState,
    success: (state, action: PayloadAction<GenerateTemporaryLinkState['links']>) => {
      state.isLoading = false;
      state.links = action.payload;
    }
  },
});

export const { actions, reducer } = generateTemporaryLinksSlice;
